import React, { useState, useEffect } from 'react'
import logo from 'image/logo.svg'
import { request } from 'meinian-package/src/utils'
import { ossImg } from 'meinian-package/src/utils/image'
import qs from 'qs'
import { Spin, message } from 'antd'
import { Icon } from 'meinian-package/src/component'
import { Input } from 'meinian-package/src/baseComponent'
import Button from 'meinian-package/src/baseComponent/button'
import './index.less'

const PHONE_VERIFY = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/
const query = qs.parse(location.search, { ignoreQueryPrefix: true })
const { shareUrl } = query

export default () => {
  const [state, setState] = useState(false)
  const [val, setVal] = useState('')
  const [info, setInfo] = useState('')

  useEffect(() => {
    fetchInfo()
  }, [])

  const fetchInfo = async () => {
    if (shareUrl) {
      try {
        const _info = await request.get('/zhikuan/ins/inspiration/get-receive-inspiration-info', { params: { shareUrl } })
        setInfo(_info)
      } catch (err) {
        console.error(err)
      }
    }
  }
  return (
    <div className="mn-receive-container">
      <div className="mobile-title"><span>灵感集领取</span></div>
      <div className="modal-content">
        <div className="content-info">
          <div className="info-title">
            <img src={logo} className="logo" />
            <span className="introduce">知衣旗下简单好用的服饰设计协作平台</span>
          </div>
          <div className="info-pic">
            <div className="pic" style={{ backgroundImage: `url(${ossImg(info.coverImgUrl || (info.lastBlogList?.length ? info.lastBlogList[0].mainUrl : ''), 244)})`, backgroundSize: '100% 100%' }} />
            <div className="inspiration-name">{info.name}</div>
            <div className="styles-box">
              <div className="design-num">
                <span className="num-title">款式</span>
                <span className="num-value">{info.blogNum}</span>
              </div>
              <div className="line" />
              <div className="design-num">
                <span className="num-title">子灵感集</span>
                <span className="num-value">{info.childNum}</span>
              </div>
            </div>
            <div className="origin">来自知衣官方的分享灵感集</div>
            <div className="mobile-styles-box">
              <div className="box-left-num">
                <div className="design-num">
                  <span className="num-title">款式</span>
                  <span className="num-value">{info.blogNum}</span>
                </div>
                <div className="line" />
                <div className="design-num">
                  <span className="num-title">子灵感集</span>
                  <span className="num-value">{info.childNum}</span>
                </div>
              </div>
              <div className="box-right-origin">来自知衣官方的分享灵感集</div>
            </div>
          </div>
        </div>
        <div className="content-action">
          {
            state ? <ReceiveSuccess phone={val} /> : <ReceiveForm phone={val} setPhone={setVal} setState={setState} />
          }
        </div>
      </div>
    </div>
  )
}

const ReceiveForm = ({ phone, setPhone, setState }) => {
  const [loading, setLoading] = useState(false)
  const onChangeValue = (_val) => {
    setPhone(_val)
  }
  const clickReceive = () => {
    copyInspiration()
  }
  const copyInspiration = async () => {
    setLoading(true)
    try {
      const res = await request.get('/ins/inspiration/copy-share-inspiration', { params: { phone, shareUrl } })
      if (res) {
        setState(true)
        message.success('灵感集领取成功')
      }
    } catch (err) {
      message.error(err.errorDesc)
      // console.log(err)
    }
    setLoading(false)
  }
  return loading ? <Spin /> : <div className="receive-box">
    <Input placeholder="请输入手机号码" value={phone} onChange={(e) => { onChangeValue(e.target.value) }} />
    <Button
      disabled={!PHONE_VERIFY.test(phone.trim())}
      type="primary"
      className="receive-bth"
      onClick={() => clickReceive()}
    >点击领取</Button>
    <div className="draw-introduce">领取后，可在美念中查看</div>
  </div>
}

const ReceiveSuccess = ({ phone }) => {
  return <div className="receive-success">
    <Icon type="m-xiaoyan_tianchong" className="success-icon" />
    <span className="success-tip">已放入您 {phone} 的账号</span>
    <span className="success-tip">可在美念网页端或知衣App中打开查看</span>
    <Button
      type="primary"
      className="receive-bth btn-pc"
      onClick={() => location.href = `${window.location.protocol}//${window.location.host}/meinian/home/coll`}
    >立即查看</Button>
  </div>
}
